import React from 'react';
import PropTypes from 'prop-types';
import css from './ColorPicker.module.scss';

const ColorPicker = ({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  error = ''
}) => {
  // Normalize value by removing # prefix if present
  const normalizedValue = value && typeof value === 'string'
    ? value.replace(/^#/, '') 
    : value || '';

  const handleColorChange = (e) => {
    let hexValue = String(e.target.value);
    if (hexValue.startsWith('#')) {
      hexValue = hexValue.substring(1);
    }

    onChange(hexValue);
  };

  const handleHexInputChange = (e) => {
    let hexValue = String(e.target.value);
    if (hexValue.startsWith('#')) {
      hexValue = hexValue.substring(1);
    }
    // Validate hex color format
    if (hexValue === '' || /^[0-9A-Fa-f]{0,6}$/.test(hexValue)) {
      onChange(hexValue);
    }
  };

  let valueWithLeadingHash = '';
  if (normalizedValue) {
    valueWithLeadingHash = `#${normalizedValue}`;
  }

  return (
    <div className={css.colorPickerContainer}>
      {label && (
        <label className={css.label}>
          {label}
          {required && <span className={css.required}>*</span>}
        </label>
      )}
      
      <div className={css.colorPickerWrapper}>
        <div 
          className={css.selectedColor}
          style={{ backgroundColor: valueWithLeadingHash || '#ffffff' }}
        >
          <input
            type="color"
            value={valueWithLeadingHash}
            onChange={handleColorChange}
            disabled={disabled}
            className={css.colorInput}
          />
        </div>
        <span className={css.hashPrefix}>{normalizedValue ? '#' : ''}</span>
        <input
          type="text"
          className={css.hexInput}
          value={normalizedValue}
          onChange={handleHexInputChange}
          disabled={disabled}
          maxLength={6}
          placeholder=""
        />
      </div>

      {error && <span className={css.error}>{error}</span>}
    </div>
  );
};

ColorPicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

export default ColorPicker; 
